export default {
    listagem: {
        titulo_pagina: 'Attribute List',
        novo: 'Create New Attribute',
        table: {
            empty: 'No Attributes Found',
            nome: 'Name',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Attribute',
            editar: 'Edit Attribute'
        },
        fields: {
            nome: {
                label: 'Name',
                description: 'Attribute Name'
            },
            status: {
                label: 'Status',
                description: 'Attribute active or inactive status'
            },
            botao_salvar : 'Save Attribute'
        },
        create: {
            success: 'Attribute created successfully!',
            error: 'Error creating Attribute!'
        },
        update: {
            success: 'Attribute successfully edited!',
            error: 'Error editing Attribute!'
        }
    }
}
